import * as React from 'react';
function calcStatus(query, filtered) {
    if (query.trim() !== '' && filtered.length === 0) {
        return 'noMatch';
    }
    if (query.trim() !== '' && filtered.length > 0) {
        return 'match';
    }
    return 'empty';
}
var Context = React.createContext({
    source: [],
    setSource: function () { },
    status: 'idle',
    query: '',
    setQuery: function () { },
    filtered: [],
    setFiltered: function () { }
});
export function useFilterState() {
    return React.useContext(getFilterCTX());
}
/**
 * HACK for passing generics to React context.
 * If there's a better way to do this, I'd love to know.
 */
export function getFilterCTX() {
    return Context;
}
export function FilterProvider(_a) {
    var children = _a.children;
    var FilterContext = getFilterCTX();
    var _b = React.useState(''), query = _b[0], setQuery = _b[1];
    var _c = React.useState([]), filtered = _c[0], setFiltered = _c[1];
    var _d = React.useState([]), source = _d[0], setSource = _d[1];
    var val = React.useMemo(function () { return ({
        source: source,
        setSource: setSource,
        status: calcStatus(query, filtered),
        query: query,
        filtered: filtered,
        setQuery: setQuery,
        setFiltered: setFiltered
    }); }, [query, filtered]);
    return React.createElement(FilterContext.Provider, { value: val }, children);
}
//# sourceMappingURL=FilterProvider.js.map